/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface LearningOutcomeTemplateDTO
 */
export interface LearningOutcomeTemplateDTO {
    /**
     * 
     * @type {string}
     * @memberof LearningOutcomeTemplateDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningOutcomeTemplateDTO
     */
    identificator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LearningOutcomeTemplateDTO
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof LearningOutcomeTemplateDTO
     */
    type?: LearningCompetenceTypeEnum;
}

export function LearningOutcomeTemplateDTOFromJSON(json: any): LearningOutcomeTemplateDTO {
    return LearningOutcomeTemplateDTOFromJSONTyped(json, false);
}

export function LearningOutcomeTemplateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningOutcomeTemplateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'identificator': !exists(json, 'identificator') ? undefined : json['identificator'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
    };
}

export function LearningOutcomeTemplateDTOToJSON(value?: LearningOutcomeTemplateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'identificator': value.identificator,
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
    };
}

